import { render, staticRenderFns } from "./TpassReceiptConfirmation.vue?vue&type=template&id=c9064712&"
import script from "./TpassReceiptConfirmation.vue?vue&type=script&lang=js&"
export * from "./TpassReceiptConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports